import { Component, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { CpService } from '../../../services/cp.service';

@Component({
  selector: 'app-campos-persona-form',
  templateUrl: './campos-persona-form.component.html',
  styleUrls: ['../cliente-form.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class CamposPersonaFormComponent {
  // Recibe de manera genérica un cliente completo o un objeto representante de la lista
  @Input() person: any;
  @Input() prefix: string = '';
  @Input() paises: any[] = [];
  @Input() listaEstados: string[] = [];
  @Input() listaColonias: any[] = [];
  @Input() esPersonaMoral: boolean = false; // <-- Añade esta línea

  @Output() fileSelected = new EventEmitter<{ file: File, campo: string }>();
  @Output() triggerDownload = new EventEmitter<any>();

  //public listaColonias: string[] = [];
  public innerLoading: boolean = false;

  constructor(
    private cpService: CpService,
    private cdRef: ChangeDetectorRef
  ) {}

  public onFileSelected(event: any, campo: string): void {
    if (event.target.files.length > 0) {
      // Avisa al orquestador padre que almacene este binario en su diccionario centralizado
      this.fileSelected.emit({ file: event.target.files[0], campo: campo });
    }
  }

  public downloadFile(idFile: any): void {
    this.triggerDownload.emit(idFile);
  }

  // Lógica Copomex encapsulada localmente por instancia de persona
  public consultarCp(): void {
    const postalCode = this.person.cp;

    if (!postalCode || postalCode.length !== 5) {
      this.listaColonias = [];
      return;
    }

    this.innerLoading = true;
    this.cpService.getDatosPorCp(postalCode).subscribe({
      next: (res: any) => {
        this.innerLoading = false;
        if (Array.isArray(res) && res.length > 0 && !res[0].error) {
          const primerRegistro = res[0].response;

          if (primerRegistro) {
            this.person.estado = primerRegistro.estado ? primerRegistro.estado.toUpperCase() : '';
            this.person.municipio = primerRegistro.municipio ? primerRegistro.municipio.toUpperCase() : '';
            this.person.ciudad = primerRegistro.ciudad ? primerRegistro.ciudad.toUpperCase() : this.person.municipio;

            this.listaColonias = res.map((item: any) => {
              return item.response && item.response.asentamiento ? item.response.asentamiento.toUpperCase() : '';
            }).filter((col: string) => col !== '');

            if (this.listaColonias.length > 0 && !this.person.colonia) {
              this.person.colonia = this.listaColonias[0];
            }
          }
        } else {
          this.listaColonias = [];
        }
        this.cdRef.detectChanges();
      },
      error: (error) => {
        this.innerLoading = false;
        console.warn('Fallo en API Copomex local.', error);
        this.listaColonias = [];
        this.cdRef.detectChanges();
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/clientes/cliente-form/component-form/campos-persona-form.component.ts